import intl from 'react-intl-universal';
import type en_US from './locales/dev_preview';

type DEV_PREVIEW = typeof en_US;
class I18N {
	get<K extends I18NKEY>(key: K, variables?: any): DEV_PREVIEW[K] {
		if (!intl.getInitOptions().currentLocale) console.log('在初始化前使用', key);
		return intl.get(key, variables).d('❌❌❌') as DEV_PREVIEW[K];
	}

	getHtml(key: I18NKEY, variables?: any): string {
		return intl.getHTML(key, variables).d('❌❌❌');
	}

	getInitOptions() {
		return intl.getInitOptions();
	}
}

const i18n = new I18N();

export default i18n;
